import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { FaqInfo } from "../core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class FaqService {
  private controllerName = "Faq";
  private apiUrl: string = `${environment.API}/${this.controllerName}`;

  constructor(private httpClient: HttpClient) {}

  getFaqInfo(): Observable<FaqInfo> {
    return this.httpClient.get<FaqInfo>(`${this.apiUrl}/info`);
  }
}
